import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import GridService from '../../components/tribe/tribe_services'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import Event1 from '../../assets/image/event1.jpg'
import Event2 from '../../assets/image/event2.jpg'
import Event3 from '../../assets/image/event3.jpg'

import Digital_Learning from '../../assets/image/digital-learning/Digital_Learning.jpg'
import content_dev from '../../assets/image/digital-learning/content_dev.jpg'
import egame from '../../assets/image/digital-learning/e-game.jpg'
import elearningimplement from '../../assets/image/digital-learning/e-learning_implement.jpg'
import info_graphic from '../../assets/image/digital-learning/info_graphic.jpg'
import mobile_learning from '../../assets/image/digital-learning/mobile_learning.jpg'
import technical from '../../assets/image/digital-learning/technical.jpg'

let data_services=[
    {
        title:"E-learning Platform Implementation",
        content:"We support your success in implementing e-learning platform initiative in your organization. Using a robust Learning Management System …",
        img:elearningimplement,
        link:'/services/digitallearning/platform'
    },
    {
        title:"Infographic Animation (Motion Graphic)",
        content:"Design your information in an attractive way and gain the attention of your audiences with a simple animated simulation to delivered your objective.",
        img:info_graphic,
        link:'/services/digitallearning/motiongraphic'
    },
    {
        title:"Mobile Learning",
        content:"We always adapt with the latest technology-based learning methodology to keep pace with the shifting learning styles of the millennials.",
        img:mobile_learning,
        link:'/services/digitallearning/mobilelearning'
    },
    {
        title:"E-Learning Content Development",
        content:"We also help you in creating and converting your conventional content delivery into interactive digital learning delivery to ensure your millennials keep engaging …",
        img:content_dev,
        link:'/services/digitallearning/content'
    },
    {
        title:"e-Game for Class Activity",
        content:"Bored with conventional classroom learning methods? We are here to help you to enrich your conventional classroom learning methods with digital …",
        img:egame,
        link:'/services/digitallearning/game'
    },
    {
        title:"Technical In-house Workshops for e-Learning Administrator …",
        content:"We share our knowledge and years of experiences as an e-learning implementor and practices in various industry and corporate. We will prepare …",
        img:technical,
        link:'/services/digitallearning/workshops'
    }
]
export default class index extends Component {
    render() {
    const image=[
        {image:Digital_Learning}
    ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='digital-section'>
                    <Banner bread_crum={['Digital Learning','']} image={image} title="We provide transformative E&#8209;Learning " subtitle="We provide transformative E-Learning and Blended Learning Solution, including:Digital Learning Innovation, Digital Learning Platform, and Digital Learning Content"/>
                    <br/><br/>
                    <div className='digital-content'>
                        <h2>Our Services</h2>
                        <br/><br/>
                        <GridService data={data_services}/>
                        <br/><br/>
                        
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
